module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "navbar customNavbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.root()
      }
    }
  }, [_c('img', {
    staticClass: "logoClass",
    attrs: {
      "src": "/static/logo.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-end"
  }, [_c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.root()
      }
    }
  }, [_vm._v("Inicio")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.about()
      }
    }
  }, [_vm._v("Nosotros")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.products()
      }
    }
  }, [_vm._v("Productos")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItemSelected"
  }, [_vm._v("Noticias")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.contact()
      }
    }
  }, [_vm._v("Contacto")]), _vm._v(" "), (_vm.isLogged) ? _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Cerrar Sesión")]) : _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v("Iniciar Sesión")])])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }), _vm._v(" "), _c('div', {
    staticClass: "column is-two-thirds"
  }, [_c('h2', {
    staticClass: "title is-2"
  }, [_vm._v(_vm._s(_vm.newsItem.title))]), _vm._v(" "), (_vm.newsItem.images.length > 0) ? _c('carousel', {
    attrs: {
      "autoplay": true,
      "perPage": 1,
      "navigationEnabled": true,
      "loop": true,
      "align": "center"
    }
  }, _vm._l((_vm.newsItem.images), function(image) {
    return _c('slide', {
      key: image.id
    }, [_c('img', {
      staticClass: "sliderImg",
      attrs: {
        "src": _vm.multimediaBase + image.imagePath,
        "alt": image.name,
        "width": "350px",
        "height": "150px"
      }
    })])
  })) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "newsInfo"
  }, [_c('i', [_vm._v(_vm._s(_vm.newsItem.dateStr))]), _vm._v(" - " + _vm._s(_vm.newsItem.description))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button customButton",
    on: {
      "click": _vm.news
    }
  }, [_vm._v("Regresar")])], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  })])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('img', {
    staticClass: "logoClass",
    attrs: {
      "src": "/static/logo.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "footerInfo"
  }, [_vm._v("\n            Nuestra misión es aportar soluciones para el control integrado de plagas que afectan la salud, la\n            tranquilidad y la economía del hombre en las diferentes áreas donde se desenvuelve, por medio de\n            asesoría técnica profesional, capacitación y productos efectivos a precios justos.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('a', {
    attrs: {
      "href": "https://www.google.com/maps/@14.5945742,-90.5766572,17.25z"
    }
  }, [_c('img', {
    staticClass: "mapInfo",
    attrs: {
      "width": "400px",
      "height": "300px",
      "src": "/static/images/newmap.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "footerContact"
  }, [_vm._v("\n            2da calle 18-87 sector B-1"), _c('br'), _vm._v("\n            Ciudad San Cristóbal zona 8 de Mixco"), _c('br'), _vm._v("\n            Guatemala"), _c('br'), _vm._v("\n            (502) 2478-1179 / 80 / 82 / 99"), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://wa.me/50240251346"
    }
  }, [_c('img', {
    staticClass: "iconImage",
    attrs: {
      "width": "20px",
      "height": "20px",
      "src": "/static/images/whatsapp-icon.png"
    }
  }), _vm._v("\n              WhatsApp: (502) 4025 - 1346\n            ")]), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:ventas@hipromeasa.com"
    }
  }, [_c('img', {
    staticClass: "iconImage",
    attrs: {
      "width": "20px",
      "height": "20px",
      "src": "/static/images/mail-icon.png"
    }
  }), _vm._v("\n              E-Mail: ventas@hipromeasa.com\n            ")]), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/hipromeasa"
    }
  }, [_c('img', {
    staticClass: "iconImage",
    attrs: {
      "width": "20px",
      "height": "20px",
      "src": "/static/images/facebook-icon.png"
    }
  }), _vm._v("\n              Estamos en Facebook\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', {
    staticClass: "footerLast"
  }, [_vm._v("2025 - Todos los derechos reservados")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a7e024a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewsDetailComponent.vue
// module id = 76
// module chunks = 0